import { render, staticRenderFns } from "./SessionDuration.vue?vue&type=template&id=3654f7f2&scoped=true&"
import script from "./SessionDuration.vue?vue&type=script&lang=js&"
export * from "./SessionDuration.vue?vue&type=script&lang=js&"
import style0 from "./SessionDuration.vue?vue&type=style&index=0&id=3654f7f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3654f7f2",
  null
  
)

export default component.exports